var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 12.3216L21.6 9.78894V14.8543L17.4 12.3216ZM21.6 23.1759L16 26.5528L10.4 23.1759V17.2663L16 20.6432L21.6 17.2663V23.1759ZM10.4 9.78894L14.6 12.3216L10.4 14.8543V9.78894ZM16.7 13.5276L20.9 16.0603L16.7 18.593V13.5276ZM15.3 18.593L11.1 16.0603L15.3 13.5276V18.593ZM20.9 8.58291L16 11.4774L11.1 8.58291L16 5.56784L20.9 8.58291ZM9 8.1005V23.8995L16 28L23 23.8995V8.1005L16 4L9 8.1005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtm);
export default __webpack_public_path__ + "static/media/FTM.22c62f400452fabb8faeb28428b29c39.svg";
export { ForwardRef as ReactComponent };